import axios from "axios";
import { Action } from "redux";
import { loadAndTrack } from "redux-request-loading";
import { ThunkAction, ThunkDispatch } from "redux-thunk";

import { AnsweredQuestionWithId } from "@teamprevent/common/questionnaires/model";
import {
    questionnaireLoaded,
    submitInvalidQuestionnaire,
    submitQuestionnaireSuccess,
    saveQuestionnaireSuccess
} from "@teamprevent/common/questionnaires/actions";
import { toast } from "@teamprevent/common/toasts";

import { FastTrackPitPupMedicalFormApi } from "./FastTrackPitPupMedicalFormApi";
import { QUESTIONNAIRE_KEY } from "./components/FastTrackPitPupMedicalForm";
import { FastTrackPitPupMedicalFormQuestionnaire } from "./models";
import {
    LOAD_SAVED_FAST_TRACK_PIT_PUP_MEDICAL_FORM,
    AUTO_SAVE_FAST_TRACK_PIT_PUP_MEDICAL_FORM,
    SUBMIT_FAST_TRACK_PIT_PUP_MEDICAL_FORM
} from "./actionTypes";

import { push } from "redux-little-router";

const fastTrackPitPupMedicalFormApi = new FastTrackPitPupMedicalFormApi(axios);

export const loadQuestionnaire = (ohCaseId?: string) => {
    return async (dispatch: ThunkDispatch<any, undefined, Action>) => {
        let result: FastTrackPitPupMedicalFormQuestionnaire;

        if (ohCaseId) {
            result = await loadAndTrack(
                dispatch,
                LOAD_SAVED_FAST_TRACK_PIT_PUP_MEDICAL_FORM,
                fastTrackPitPupMedicalFormApi.getByTaskId(ohCaseId));
        }
        else {
            result = await loadAndTrack(
                dispatch,
                LOAD_SAVED_FAST_TRACK_PIT_PUP_MEDICAL_FORM,
                fastTrackPitPupMedicalFormApi.get());
        }

        if (result?.data) {
            dispatch(questionnaireLoaded({
                questions: result.data ? result.data.questions : [],
                questionnaireKey: QUESTIONNAIRE_KEY
            }));
        }

        return result;
    };
};

export const saveQuestionnaire = (questions: AnsweredQuestionWithId[], eTag: string) => {
    return async (dispatch: ThunkDispatch<any, undefined, Action>) => {
        const response = await loadAndTrack(
            dispatch,
            AUTO_SAVE_FAST_TRACK_PIT_PUP_MEDICAL_FORM,
            fastTrackPitPupMedicalFormApi.save(questions, eTag)
        );
        dispatch(saveQuestionnaireSuccess({ questionnaireKey: QUESTIONNAIRE_KEY, eTag: response.eTag }));
    };
};

export const submitQuestionnaire = (questions: AnsweredQuestionWithId[], customerId: string):
    ThunkAction<any, any, undefined, Action> => {
    if (!questions.every(question => question.isValid)) {
        return (dispatch: ThunkDispatch<any, undefined, Action>) => dispatch(submitInvalidQuestionnaire(QUESTIONNAIRE_KEY, true));
    }
    return async (dispatch: ThunkDispatch<any, undefined, Action>) => {
        const response = await loadAndTrack(
            dispatch,
            SUBMIT_FAST_TRACK_PIT_PUP_MEDICAL_FORM,
            fastTrackPitPupMedicalFormApi.submit(questions, customerId));
        toast.success("Fast Track PIT/PUP Medical Form submitted successfully");
        dispatch(push(""));
        dispatch(submitQuestionnaireSuccess(QUESTIONNAIRE_KEY));
        return response.data;
    };
};
